<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="horario" titulo="Horario / Coordinación" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div id="banner" align="center" *ngIf="ctrl.cargando || ctrl.cargarDatosCatalogo || cargando">
  <div class="bloquear-azul">

  </div>
  <span class="tag is-primary is-large " style="position: absolute; top: 45%; font-size: 2em; z-index: 999999999;  left: 45%;">
    <span class="icon">
      <i class="icon-worldwide fa-spin"></i>
    </span> &nbsp;
    <span>Cargando...</span>
  </span>
</div>

<div class="contenedor columns " style="height:100%; ">

    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>

                <section class="section" style="padding: 1rem !important; overflow:auto; height: 85.8vh;" >
                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <!-- acargar catalogo se agrega un 4to parametro para determinar donde se guarda la animacion cargando en este caso ctrl.cargando_periodo -->
                    <a id="catalogos" (click)="ctrl.cargarCatalogo('periodos_escolares', 'periodo-escolar-catalogo', '', 'cargando_periodo'); ctrl.cargarCatalogo('carreras_planes', 'carrera-plan', '', 'cargando_carrera'); ctrl.cargarCatalogo('profesores_horarios', 'empleado?id=2'); "></a>
                    
                    <a id="cargar_horario" (click)="iniciar_horario(); "></a>

                    <a id="imprimir_local" (click)="jsonTabla();"></a>
                    <a id="logo64" (click)="asignarLogos(ctrl.logos64); "></a>
                    <div class="columns">
                        <div class="column is-4">
                            <label class="label">Período escolar:</label>
                            <!-- se agrega solo estas clasees control has-icons-left has-icons-right para mostrar los iconos dentro del componente -->
                            <div class="control has-icons-left has-icons-right">
                                <!-- Muestra la animacion cargando left -->
                                <span class="icon is-small is-left">
                                  <i class="icon-worldwide fa-spin"  *ngIf="ctrl.cargando_periodo"></i>
                                </span>

                                <ng-select2 [disabled]="ctrl.periodos_escolares ? ctrl.periodos_escolares.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.periodos_escolares_id.value"
                                (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.periodos_escolares_id);"
                                [data]="ctrl.periodos_escolares"></ng-select2>

                                <!-- Muestra el warning de error right-->
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('periodos_escolares_id').hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                </span>

                                <span class="help is-danger" *ngIf="ctrl.dato.get('periodos_escolares_id').hasError('required') ">Este campo es requerido.</span>
                            </div>
                        </div>

                        <div class="column is-4">
                            <label class="label">Carrera/Plan:</label>
                            <div class="control has-icons-left has-icons-right">
                                <span class="icon is-small is-left">
                                  <i class="icon-worldwide fa-spin" *ngIf="ctrl.cargando_carrera"></i>
                                </span>

                                <ng-select2 [disabled]="ctrl.carreras_planes ? ctrl.carreras_planes.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="ctrl.dato.controls.carreras_planes_id.value"
                                (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.carreras_planes_id);  ctrl.cargarCatalogo('logos64', 'logos64?carreras_planes_id='+ctrl.dato.get('carreras_planes_id').value, 'logo64');"
                                [data]="ctrl.carreras_planes"></ng-select2>

                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('carreras_planes_id').hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('carreras_planes_id').hasError('required') ">Este campo es requerido.</span>
                            </div>
                        </div>

                        <div class="column is-3">
                            <label class="label">Grupo:</label>
                            <div class="control has-icons-left has-icons-right">
                                <div class="select">
                                    <select class="select" formControlName="temp_grupos_id" (change)="iniciar_dias_grupo(ctrl.dato.controls.modulos_periodos_escolares)">
                                        <option value="">Seleccione</option>
                                        <option *ngFor="let item of grupos; let ig = index" value="{{ig}}">{{item.clave}} {{item.nivel}} {{item.identificador}}</option>
                                    </select>
                                </div>

                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('grupos_id').hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('grupos_id').hasError('required') ">Este campo es requerido.</span>
                            </div>
                        </div>
                        <div class="column is-1">
                          <label class="label">.</label>
                            
                          <a id="recargar" class="button navbar-item  is-success tooltip" (click)="carrera_plan($event, ctrl.dato.controls.carreras_planes_id, 'grupo-periodo-carrera', 'grupos', ctrl.periodos_escolares); ">
                            <i class="fa fa-search"></i>
                             Buscar
                          </a>
                        </div>
                    </div>

                    <section class="hero" style="background:gainsboro">
                        <div class="hero-body" style="padding: 0.5rem 1.5rem;">
                            <p class="title">
                                <span class="icon is-medium ng-star-inserted">
                                    <i class="fa fa-calendar"></i>
                                </span>
                                Programación de Horarios

                                <button class="navbar-item  is-success tooltip" type="button" (click)="iniciarProfesor();" style="float: right;">
                                  <span class="icon fa-2x has-text-success">
                                    <i class="icon-user-12"></i>
                                  </span>
                                  <span class="tooltiptext">Horario por docente</span>
                                </button>

                                <button class="navbar-item  is-success tooltip" type="button" (click)="generarPDF()" style="float: right;" *ngIf="tieneid">
                                  <span class="icon fa-2x has-text-success">
                                    <i class="icon-printer"></i>
                                  </span>
                                  <span class="tooltiptext">PDF</span>
                                </button>

                            </p>
                            <p class="subtitle" *ngIf="ctrl.dato.get('temp_grupos_id').value">
                              <small>
                                <strong>Periodo Escolar:</strong> {{grupo_sel.periodos_escolares.nombre}} / {{grupo_sel.periodos_escolares.tipos_periodos.nombre}} / {{grupo_sel.periodos_escolares.modalidades.nombre}}
                              </small>
                              <small>
                                <strong>Carrera/Plan:</strong> {{grupo_sel.carreras_planes.carreras.nombre}} - {{grupo_sel.carreras_planes.planes_estudios.nombre}}
                              </small>
                              <small>
                                <strong>Grupo:</strong> {{grupo_sel.clave}} {{grupo_sel.nivel}} {{grupo_sel.identificador}}
                              </small>
                              <small>
                                <strong>Turno:</strong> {{grupo_sel.turnos?.nombre}}
                              </small>
                            </p>
                        </div>
                    </section>
                    <div class="tabs is-boxed" >
                      <ul>
                        <li *ngFor="let modul of ctrl.dato.controls.modulos_periodos_escolares.controls; let im = index" [ngClass]="{ 'is-active' : tab == im}">
                          <a (click)="tab=im">
                            <span class="icon ">
                              <i class="fa fa-calendar"></i>
                            </span>
                            <span>{{ctrl.dato.controls.modulos_periodos_escolares.controls[im].controls.nombre.value}}</span>
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div formArrayName="modulos_periodos_escolares" *ngIf="ctrl.dato.controls.modulos_periodos_escolares.length > 0">
                      <div *ngFor="let modul of ctrl.dato.controls.modulos_periodos_escolares.controls; let im = index" [formGroupName]="im" [ngClass]="{ 'is-hidden': tab != im}" >

                        <div class="columns">
                          <div class="column is-3">
                            <label class="label">Nombre:</label>
                            <div class="control has-icons-left has-icons-right">
                              <input class="input" type="text" [ngClass]="{'is-danger': modul.controls.nombre.hasError('required')}"
                                placeholder="Nombre" formControlName="nombre">
                              <span class="icon is-small is-right" *ngIf="modul.controls.nombre.hasError('required') ">
                                <i class="fa fa-warning"></i>
                              </span>
                              <span class="help is-danger" *ngIf="modul.controls.nombre.hasError('required') ">Este campo es
                                requerido.</span>
                            </div>
                          </div>

                          <div class="column is-4">
                            <label class="label">Fecha inicio:</label>
                            <div class="control has-icons-left has-icons-right">
                              <input class="input" type="date" [ngClass]="{'is-danger': modul.controls.fecha_inicio.hasError('required')}"
                                formControlName="fecha_inicio" >
                              <span class="icon is-small is-right" *ngIf="modul.controls.fecha_inicio.hasError('required') ">
                                <i class="fa fa-warning"></i>
                              </span>
                              <span class="help is-danger" *ngIf="modul.controls.fecha_inicio.hasError('required') ">Este campo es
                                requerido.</span>
                            </div>
                          </div>

                          <div class="column is-4">
                            <label class="label">Fecha fin:</label>
                            <div class="control has-icons-left has-icons-right">
                              <input class="input" type="date" [ngClass]="{'is-danger': modul.controls.fecha_fin.hasError('required')}"
                                formControlName="fecha_fin" min="modul.controls.fecha_inicio').value">
                              <span class="icon is-small is-right" *ngIf="modul.controls.fecha_fin.hasError('required') ">
                                <i class="fa fa-warning"></i>
                              </span>
                              <span class="help is-danger" *ngIf="modul.controls.fecha_fin.hasError('required') ">Este campo es
                                requerido.</span>
                            </div>
                          </div>
                          <div class="column is-1">
                            <button type="button" class="tooltip" (click)="ctrl.abrirModal('parcial-horario' + im)" style="width: 100%; height: 100%;">
                              <span class="icon fa-4x has-text-link">
                                <i class="icon-calendar-16"></i>
                              </span>
                              <span class="tooltiptext">Fecha de examenes</span>
                            </button>
                          </div>

                          <div class="modal" id="parcial-horario{{im}}" formArrayName="periodos_escolares_parciales">
                            <div class="modal-background"></div>
                            <div class="modal-card" style="width: 60%">
                              <header class="modal-card-head">
                                <p class="modal-card-title">
                                  <i class="fa fa-success"></i> Programación de fechas de examen</p>
                                <button class="delete"  type="button" (click)="ctrl.cancelarModal('parcial-horario'+im)"></button>
                              </header>
                              <section class="modal-card-body">
                                <div class="content">
                                  <div *ngFor="let PEParcial of modul.controls.periodos_escolares_parciales.controls; let pep = index;" [formGroupName]="pep">
                                    <div class="box" [style.background]="pep%2 == 0 ? 'rgba(220, 220, 220, 0.28)' : '#ffffff'" style="padding: 0px 1.25rem;">
                                      <article class="media">
                                        <div class="media-left">
                                          <p style="font-size:1.5em">
                                            <strong>Parcial #{{PEParcial.controls.numero_parcial.value}}</strong>
                                          </p>
                                        </div>
                                        <div class="media-content">
                                          <div class="content" align="center">
                                            <div class="columns">
                                              <div class="column is-4">
                                                <div class="field">
                                                  <label class="label">Fecha de inicio:</label>
                                                  <div class="control is-expanded  has-icon has-icon-left">
                                                    <input class="input" type="date" formControlName="fecha_inicio" [ngClass]="{'is-danger': PEParcial.controls.fecha_inicio.hasError('required')}">
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="column is-4">
                                                <div class="field">
                                                  <label class="label">Fecha de termino:</label>
                                                  <div class="control is-expanded  has-icon has-icon-left">
                                                    <input class="input" type="date" formControlName="fecha_fin" [ngClass]="{'is-danger': PEParcial.controls.fecha_fin.hasError('required')}">
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="column is-4">
                                                <div class="field">
                                                  <label class="label">Número de días:</label>
                                                  <div class="control is-expanded  has-icon has-icon-left">
                                                    <input class="input" type="number" placeholder="Para reportar calificación" formControlName="dias_reportar_calificacion" [ngClass]="{'is-danger': PEParcial.controls.dias_reportar_calificacion.hasError('required')}">
                                                  </div>
                                                </div>
                                            </div>
                                            </div>
                                          </div>
                                        </div>
                                      </article>
                                    </div>
                                  </div>
                                </div>
                              </section>
                              <footer class="modal-card-foot">
                                <a class="button" (click)="ctrl.cancelarModal('parcial-horario'+im)">Continuar</a>
                              </footer>
                            </div>
                          </div>

                        </div>

                        <div class="columns is-gapless" formArrayName="horarios_dias" [style.width.px]="width - 66">
                            <div class="column col-principal" *ngFor="let item of modul.controls.horarios_dias.controls; let i = index" [style.width.%]="(100 / modul.get('horarios_dias').value.length)">
                                <p class="bd-notification " style="background:gainsboro; text-shadow: none; padding: 0.25rem 0;" >
                                    <span class="icon ">
                                        <i class="fa fa-calendar"></i>
                                    </span>
                                    <span>{{dias[item.value.dias_semanas_id - 1]}}</span>
                                </p>
                                <div style="width:100%; margin-bottom:30px;">
                                    <a style="float:left; width:50%" class="button" (click)="ctrl.agregar_form_array(item.controls.horarios_detalles, horarios_detalles)"
                                        *ngIf="ctrl.dato.get('turnos_id').value != ''">
                                        <span class="icon has-text-success">
                                            <i class="icon-add2"></i>
                                        </span>
                                        <span class="tooltiptext">Agregar</span>
                                    </a>
                                    <a style="float:right; width:50%" class="button" (click)="iniciar_limpiar(im, i)" >
                                        <span class="icon has-text-danger">
                                            <i class="icon-trash"></i>
                                        </span>
                                        <span class="tooltiptext">Limpiar</span>
                                    </a>
                                </div>
                                <div [formGroupName]="i">
                                    <div formArrayName="horarios_detalles">
                                        <div *ngFor="let val of item.controls.horarios_detalles.controls; let i2=index">
                                            <nav class="panel" [formGroupName]="i2">
                                                <div class="panel-heading">
                                                    {{val.value.hora_inicio}} - {{val.value.hora_termino}}

                                                    <a style="float:right; " class="is-danger" (click)="ctrl.quitar_form_array(item.controls.horarios_detalles, i2)">
                                                        <span class="icon has-text-danger">
                                                            <i class="icon-trash"></i>
                                                        </span>
                                                    </a>

                                                    <a style="float:right; " *ngIf="profesores_configurados[im]" class="is-success" (click)="ctrl.abrirModal('profesores_configurados' + im + i + i2)">
                                                      <span class="icon has-text-success">
                                                        <i class="icon-user-12"></i>
                                                      </span>
                                                    </a>

                                                    <div class="modal" id="profesores_configurados{{im}}{{i}}{{i2}}" *ngIf="profesores_configurados[im]">
                                                      <div class="modal-background"></div>
                                                      <div class="modal-card" style="width: 760px;" *ngIf="profesores_configurados[im][item.controls.dias_semanas_id.value]">
                                                        <header class="modal-card-head">
                                                          <p class="modal-card-title">
                                                            <i class="icon-user-12"></i> Profesores configurados para este horario y para esta materia</p>
                                                          <button class="delete" type="button" (click)="ctrl.cancelarModal('profesores_configurados' + im + i + i2)"></button>
                                                        </header>
                                                        <section class="modal-card-body">
                                                          <div class="content">
                                                            <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" >
                                                              <thead>
                                                                <tr>
                                                                  <th width="10%">Disponible</th>
                                                                  <th width="90%">Docente</th>
                                                                </tr>
                                                              </thead>
                                                              <tbody>
                                                                <tr *ngFor="let per of profesores_configurados[im][item.controls.dias_semanas_id.value][i2]">
                                                                  <td>
                                                                    {{per.disponible}}
                                                                  </td>
                                                                  <td>
                                                                    {{per.nombre}}
                                                                  </td>
                                                                </tr>
                                                              </tbody>
                                                            </table>
                                                          </div>
                                                        </section>
                                                        <footer class="modal-card-foot">
                                                          <a class="button is-success" (click)="ctrl.cancelarModal('profesores_configurados' + im + i + i2)">Cerrar</a>
                                                        </footer>
                                                      </div>
                                                    </div>
                                                </div>
                                                <label class="panel-block">
                                                  <div class="field" style="width: 100%;">
                                                    <label class="label">Hora Inicio: </label>
                                                    <p class="control has-icons-left has-icons-right">
                                                          <input class="input" type="time" [ngClass]="{'is-danger': val.controls.hora_inicio.hasError('required')}" formControlName="hora_inicio"
                                                            (keypress)="calcular_horan_fin(val.value.hora_inicio, im, val.controls, item, i2)" (change)="calcular_horan_fin(val.value.hora_inicio, im, val.controls, item, i2)">
                                                        <span class="help is-danger" *ngIf="val.controls.hora_inicio.errors?.required">Este campo es requerido.</span>
                                                        <span class="help is-danger" *ngIf="val.controls.hora_inicio.errors?.min">El minimo es {{hora_inicio}}.</span>
                                                    </p>
                                                    </div>
                                                </label>

                                                <label class="panel-block">
                                                  <div class="field" style="width: 100%;">
                                                    <label class="label">Materia: </label>
                                                    <div class="control has-icons-left has-icons-right"  >

                                                        <ng-select2 [disabled]="materias ? materias.length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="val.controls.materias_id.value"
                                                        (valueChanged)="ctrl.seleccionarValorSelect2($event, val.controls.materias_id); cambiar_materia(val.controls, im, item, i2);"
                                                        [data]="materias"></ng-select2>
                                                        <span class="help is-danger" *ngIf="!val.controls.materias_id.valid">Este campo es requerido.</span>
                                                    </div>
                                                    </div>
                                                </label>

                                                <label class="panel-block" *ngIf="profesores[im]">
                                                  <div class="field" style="width: 100%;">
                                                    <label class="label">Profesor: </label>
                                                    <div class="control has-icons-left has-icons-right"  >
                                                        <div  *ngIf="profesores[im][item.value.dias_semanas_id]">

                                                            <ng-select2 [disabled]="profesores[im][item.value.dias_semanas_id][i2] ? profesores[im][item.value.dias_semanas_id][i2].length == 0 ? true : false : true" [options]="ctrl.optionSelect" [value]="val.controls.personas_id.value"
                                                          (valueChanged)="ctrl.seleccionarValorSelect2($event, val.controls.personas_id); "
                                                          [data]="profesores[im][item.value.dias_semanas_id][i2]"></ng-select2>
                                                        </div>
                                                        <span class="help is-danger" *ngIf="!val.controls.materias_id.valid">Este campo es requerido.</span>
                                                    </div>
                                                    </div>
                                                </label>

                                            </nav>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                      </div>
                    </div>
                </section>


              </form>
        </div>
    </div>
</div>

<div class="modal" id="confirmarLimpiar">
    <div class="modal-background"></div>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">
                <i class="fa fa-warning"></i> Alerta</p>
            <button class="delete"  type="button"(click)="ctrl.cancelarModal('confirmarLimpiar')"></button>
        </header>
        <section class="modal-card-body">
            <div class="content">
                <h1>¿Esta seguro de limpiar el dia?</h1>
                <p>Ya no se podra recuperar la información</p>
            </div>
        </section>
        <footer class="modal-card-foot">
            <a class="button is-success" (click)="limpiar_dia(ctrl.dato.controls.modulos_periodos_escolares.controls[limpiarIndem].controls.horarios_dias.controls, limpiarIndex)">Continuar</a>
            <a class="button" (click)="ctrl.cancelarModal('confirmarLimpiar')">Cancelar</a>
        </footer>
    </div>
</div>

<div class="modal" id="profesor-horario" *ngIf="!imprimirhorario">
  <div class="modal-background"></div>
  <div class="modal-card" style="width: 75%;">
    <header class="modal-card-head">
      <p class="modal-card-title">
        <i class="fa fa-success"></i> Consultar horario del docente</p>
      <button class="delete"  type="button"(click)="ctrl.cancelarModal('profesor-horario')"></button>
    </header>
    <section class="modal-card-body">
      <div class="content">
        <div class="field">
          <label class="label">Seleccione el docente:</label>
          <ng-select2 [disabled]="ctrl.profesores_horarios ? ctrl.profesores_horarios.length == 0 ? true : false : true" [options]="ctrl.optionSelect" (valueChanged)="profesorHorarioMetodo($event);" [data]="ctrl.profesores_horarios"></ng-select2>
        </div>

        <div *ngIf="profesorhorario" class="content">

          <div *ngFor="let modulo of ph_modulos['ESCOLARIZADO']; let i = index">
            <div class="box">
              <article class="media">
                <div class="media-left">
                  <figure class="image is-64x64">
                    <img src="{{API_PATH}}/adjunto/configuracion/{{configuracion.sucursal.logo != '' ? configuracion.sucursal.logo : configuracion.empresa.logo}}">
                  </figure>
                </div>
                <div class="media-content">
                  <div class="content" align="center">
                    <h3>{{configuracion.empresa.nombre}}</h3>
                    <h4>{{configuracion.sucursal.nombre}}</h4>

                    <p>DOCENTE: {{profesorhorario.docente.nombre}}</p>

                  </div>
                </div>
              </article>
            </div>

            <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" id="tabla{{i}}">
              <caption><strong>MÓDULO: del {{modulo}}</strong></caption>
              <thead>
                <tr>
                  <th width="10%">Hora/Día</th>
                  <th width="18%" *ngFor="let dia of ph_dias['ESCOLARIZADO']">{{dias_semanas[dia]}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let hora of ph_horas['ESCOLARIZADO']">
                  <td>
                    <div>{{hora.split('-')[0]}}</div>
                    <div>{{hora.split('-')[1]}}</div>
                  </td>
                  <td *ngFor="let dia of ph_dias['ESCOLARIZADO']" width="{{88/ph_dias.length}}%">
                    <div *ngIf="profesorhorario.horario['ESCOLARIZADO'][modulo][dia]" align="center">
                      <div>{{profesorhorario.horario['ESCOLARIZADO'][modulo][dia][hora]?.nombre}}</div>
                      <small>{{profesorhorario.horario['ESCOLARIZADO'][modulo][dia][hora]?.clave}}</small>
                      <div>{{profesorhorario.horario['ESCOLARIZADO'][modulo][dia][hora]?.grupo}}</div>
                      <small>{{profesorhorario.horario['ESCOLARIZADO'][modulo][dia][hora]?.turno}}</small>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>

          <div *ngFor="let modalidad of ph_modalidades">
            <div *ngIf="modalidad != 'ESCOLARIZADO'">
              <div class="box">
                <article class="media">
                  <div class="media-left">
                    <figure class="image is-64x64">
                      <img src="{{API_PATH}}/adjunto/configuracion/{{configuracion.sucursal.logo != '' ? configuracion.sucursal.logo : configuracion.empresa.logo}}">
                    </figure>
                  </div>
                  <div class="media-content">
                    <div class="content" align="center">
                      <h3>{{configuracion.empresa.nombre}}</h3>
                      <h4>{{configuracion.sucursal.nombre}}</h4>

                      <p>DOCENTE: {{profesorhorario.docente.nombre}}</p>

                    </div>
                  </div>
                </article>
              </div>

              <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" *ngFor="let dia of ph_dias[modalidad]">
                <thead>
                  <tr>
                    <th>
                      <h2 align="center">{{dias_semanas[dia]}}</h2>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <td>
                    <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" id="tabla{{i}}">
                      <thead>
                        <tr>
                          <th width="200">Hora/Modulo</th>
                          <th *ngFor="let modulo of ph_modulos[modalidad]; let i = index">{{modulo}}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let hora of ph_horas[modalidad]">
                          <td>
                            <div>{{hora.split('-')[0]}}</div>
                            <div>{{hora.split('-')[1]}}</div>
                          </td>
                          <td *ngFor="let modulo of ph_modulos[modalidad]; let i = index" width="{{88/ph_dias.length}}%">
                            <div *ngIf="profesorhorario.horario[modalidad][modulo][dia]" align="center">
                              <div>{{profesorhorario.horario[modalidad][modulo][dia][hora]?.nombre}}</div>
                              <small>{{profesorhorario.horario[modalidad][modulo][dia][hora]?.clave}}</small>
                              <div>{{profesorhorario.horario[modalidad][modulo][dia][hora]?.grupo}}</div>
                              <small>{{profesorhorario.horario[modalidad][modulo][dia][hora]?.turno}}</small>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tbody>
              </table>

            </div>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot">
      <a class="button" (click)="ctrl.cancelarModal('profesor-horario')">Cancelar</a>
    </footer>
  </div>
</div>

<div *ngIf="imprimirhorario && profesorhorario.modalidades.modalidades_dias.length > 2">
  <div *ngFor="let modulo of ph_modulos; let i = index">
    <table class="table is-bordered is-striped is-narrow is-hoverable is-fullwidth" id="tablahorario{{i}}">
      <thead>
        <tr>
          <th width="200">Hora/Día</th>
          <th *ngFor="let dia of ph_dias">{{dia}}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let hora of ph_horas">
          <td>
            <div>{{hora.split('-')[0]}}</div>
            <div>{{hora.split('-')[1]}}</div>
          </td>
          <td *ngFor="let dia of ph_dias">
            <div *ngIf="profesorhorario.horario[modulo][dia]" align="center">
              <div>{{profesorhorario.horario[modulo][dia][hora]?.nombre}}</div>
              <small>{{profesorhorario.horario[modulo][dia][hora]?.clave}}</small>
              <div>{{profesorhorario.horario[modulo][dia][hora]?.docente}}</div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
